import { ISearchUser } from "api/user/types";
import { useState } from "react";
import { toast } from "react-toastify";

interface IUseSelectUserProps {
  users: ISearchUser[] | null;
  selecteds: number[];
}

export const useSelectUser = ({ users, selecteds }: IUseSelectUserProps) => {
  const [selectedUsers, setSelectedUsers] = useState<number[]>(selecteds);

  const toggleUser = (id: number, locked?: boolean) => {
    if (locked) {
      // unable to remove user if is selected before
      if (!selectedUsers.includes(id)) {
        // add new user
        setSelectedUsers((prevSelected) => [...prevSelected, id]);
      } else if (!selecteds.includes(id)) {
        // remove user if wasn't selected before opening modal
        setSelectedUsers(selectedUsers.filter((userId) => userId !== id));
      } else {
        toast.error("امکان حذف کاربر وجود ندارد");
      }
    } else {
      if (!selectedUsers.includes(id)) {
        // add new user
        setSelectedUsers([...selectedUsers, id]);
      } else {
        // remove user
        setSelectedUsers(selectedUsers.filter((userId) => userId !== id));
      }
    }
  };

  const selectAllUsers = (locked?: boolean) => {
    if (users?.length === selectedUsers?.length) {
      if (locked) {
        setSelectedUsers(selecteds);
      } else {
        setSelectedUsers([]);
      }
    } else {
      setSelectedUsers(users!.map((user) => user.id));
    }
  };

  return {
    selectedUsers,
    toggleUser,
    selectAllUsers,
  };
};
